import { CeaseFormValues, CeaseRequestDetails } from './cease';

export enum CeaseActionTypes {
  SET_ACTIVE_CUSTOMER = 'CEASE/SET_ACTIVE_CUSTOMER',

  CREATE_CEASE = 'CEASE/CREATE_CEASE',
  CREATE_CEASE_STARTED = 'CEASE/CREATE_CEASE_STARTED',
  CREATE_CEASE_SUCCESS = 'CEASE/CREATE_CEASE_SUCCESS',
  CREATE_CEASE_ERROR = 'CEASE/CREATE_CEASE_ERROR',
  CREATE_CEASE_ENDED = 'CEASE/CREATE_CEASE_ENDED',

  GET_CEASES = 'CEASE/GET_CEASES',
  GET_CEASES_STARTED = 'CEASE/GET_CEASES_STARTED',
  GET_CEASES_SUCCESS = 'CEASE/GET_CEASES_SUCCESS',
  GET_CEASES_ERROR = 'CEASE/GET_CEASES_ERROR',
  GET_CEASES_ENDED = 'CEASE/GET_CEASES_ENDED',

  GET_CEASE = 'CEASE/GET_CEASE',
  GET_CEASE_STARTED = 'CEASE/GET_CEASE_STARTED',
  GET_CEASE_SUCCESS = 'CEASE/GET_CEASE_SUCCESS',
  GET_CEASE_ERROR = 'CEASE/GET_CEASE_ERROR',
  GET_CEASE_ENDED = 'CEASE/GET_CEASE_ENDED',

  RESET_CEASE_ERROR = 'CEASE/RESET_CEASE_ERROR',
}

export interface ICreateCeaseStarted {
  type: CeaseActionTypes.CREATE_CEASE_STARTED;
}

export interface ISetActiveCustomer {
  type: CeaseActionTypes.SET_ACTIVE_CUSTOMER;
  payload: {
    customerId: string;
  };
}

export interface ICreateCeaseEnded {
  type: CeaseActionTypes.CREATE_CEASE_ENDED;
}

export interface IGetCeasesStarted {
  type: CeaseActionTypes.GET_CEASES_STARTED;
}

export interface IGetCeasesEnded {
  type: CeaseActionTypes.GET_CEASES_ENDED;
}

export interface IGetCeaseStarted {
  type: CeaseActionTypes.GET_CEASE_STARTED;
}

export interface IGetCeaseEnded {
  type: CeaseActionTypes.GET_CEASE_ENDED;
}

export interface ICreateCease {
  type: CeaseActionTypes.CREATE_CEASE;
  payload: {
    form: CeaseFormValues;
    customerId: string;
    customerName: string;
    submittedBy: string;
  };
}

export interface IGetCeases {
  type: CeaseActionTypes.GET_CEASES;
  payload: {
    customerId: string;
  };
}

export interface IGetCease {
  type: CeaseActionTypes.GET_CEASE;
  payload: {
    customerId: string;
    id: string;
  };
}

export interface ICreateCeaseSuccess {
  type: CeaseActionTypes.CREATE_CEASE_SUCCESS;
  payload: { cease: CeaseRequestDetails };
}

export interface IGetCeasesSuccess {
  type: CeaseActionTypes.GET_CEASES_SUCCESS;
  payload: { ceases: CeaseRequestDetails[] };
}

export interface IGetCeaseSuccess {
  type: CeaseActionTypes.GET_CEASE_SUCCESS;
  payload: { cease: CeaseRequestDetails };
}

export interface ICeaseError {
  type: CeaseActionTypes.CREATE_CEASE_ERROR | CeaseActionTypes.GET_CEASES_ERROR | CeaseActionTypes.GET_CEASE_ERROR;
  payload: { message: string };
}

export type ICreateCeaseError = ICeaseError & { type: CeaseActionTypes.CREATE_CEASE_ERROR };
export type IGetCeasesError = ICeaseError & { type: CeaseActionTypes.GET_CEASES_ERROR };
export type IGetCeaseError = ICeaseError & { type: CeaseActionTypes.GET_CEASE_ERROR };

export interface IResetCeaseError {
  type: CeaseActionTypes.RESET_CEASE_ERROR;
}

export type CeaseActions =
  | ISetActiveCustomer
  | ICreateCease
  | ICreateCeaseStarted
  | IGetCeases
  | IGetCeasesStarted
  | IGetCease
  | IGetCeaseStarted
  | ICreateCeaseSuccess
  | IGetCeasesSuccess
  | IGetCeaseSuccess
  | ICeaseError
  | ICreateCeaseEnded
  | IGetCeasesEnded
  | IGetCeaseEnded
  | IResetCeaseError;
